// No 0/O, 1/l/I: the manager reads this out or writes it down.
const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const LOWER = "abcdefghjkmnpqrstuvwxyz";
const DIGITS = "23456789";
const ALPHABET = UPPER + LOWER + DIGITS;
const LENGTH = 12;

function randomIndex(size: number): number {
  // Rejection sampling, so every character is equally likely.
  const limit = Math.floor(0x1_0000_0000 / size) * size;
  let value: number;
  do {
    value = crypto.getRandomValues(new Uint32Array(1))[0] ?? limit;
  } while (value >= limit);
  return value % size;
}

function meetsSetPasswordRules(password: string): boolean {
  return (
    /[A-Z]/.test(password) && /[a-z]/.test(password) && /\d/.test(password)
  );
}

/**
 * A temporary password for a manager to hand over. It passes the rules the
 * user's own new password must meet (at least 8 characters, an uppercase
 * letter and a number), plus a lowercase letter.
 */
export function generateTemporaryPassword(): string {
  for (;;) {
    let password = "";
    for (let i = 0; i < LENGTH; i++) {
      password += ALPHABET.charAt(randomIndex(ALPHABET.length));
    }
    if (meetsSetPasswordRules(password)) {
      return password;
    }
  }
}
